// extracted by mini-css-extract-plugin
export var emailBlockLink = "_hv-0";